import { render, staticRenderFns } from "./SpellCheck.vue?vue&type=template&id=0e6bcb6e&"
import script from "./SpellCheck.vue?vue&type=script&lang=js&"
export * from "./SpellCheck.vue?vue&type=script&lang=js&"
import style0 from "./SpellCheck.vue?vue&type=style&index=0&id=0e6bcb6e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports